import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';

import { UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from 'src/app/SayTS/auth.service';
import { Router } from '@angular/router';
import { Fce } from 'src/app/SayTS/fce';
import { SharedService } from 'src/app/_shared/shared.service';
import { SsoLoginComponent } from 'src/app/login/sso-login.component';
import { TestLoginSelectorComponent } from 'src/app/login/test-login-selector/test-login-selector.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.test.html',
  imports: [ReactiveFormsModule, TranslateModule, SsoLoginComponent, TestLoginSelectorComponent]
})
export class LoginComponent implements OnInit {
  loginForm: UntypedFormGroup;

  constructor(protected fb: UntypedFormBuilder, protected authService: AuthService, protected shared: SharedService,
    protected router: Router) { }

  ngOnInit() {
    this.loginForm = this.fb.group({
      username: [null, [Validators.required]],
      password: [null, Validators.required],
      rememberMe: [false]
    });

    console.log("LOGIN", this.shared.login)
    if (this.shared.isLoggedIn())
      this.loginSuccess();
  }

  async loginPass() {
    const form = this.loginForm.controls
    await this.authService.loginUser({ username: form.username.value, password: form.password.value, rememberMe: form.rememberMe.value })
    if (this.shared.isLoggedIn()) {
      this.loginSuccess();
    }
  }

  loginSuccess() {
    const excluded = ['/loginChip']
    if (Fce.empty(this.shared.getAny("last_wanted_url")) || excluded.includes(this.shared.getAny("last_wanted_url")))
      this.router.navigate(['/dashboard'])
    else {
      console.log("redirecting to ", this.shared.getAny("last_wanted_url"))
      this.router.navigate([this.shared.getAny("last_wanted_url")])
      this.shared.setAny("last_wanted_url", null)
    }
  }

}
